import shoppingCart from './shopping-cart';
import checkout from './checkout';
import expressQuote from './express-quote';
import checkoutErp from './erp';
import cat4mro from './cat4mro';
import requestInformation from './request-information';

export default {
  shoppingCart,
  checkout,
  expressQuote,
  checkoutErp,
  cat4mro,
  requestInformation,
};



// WEBPACK FOOTER //
// ./src/store/modules/buyer/index.js